
import AccountDrawer from '@marketplace/components/AccountDrawer.vue'
import HeaderCart from '@marketplace/components/core/HeaderCart.vue'
import HeaderInlineMenu from '@marketplace/components/core/HeaderInlineMenu.vue'
import HeaderMobileMenu from '@marketplace/components/core/HeaderMobileMenu.vue'
import HowOcWorksOptions from '@marketplace/components/home-page/parts/how-oc-works-options.vue'
import {
    GUEST_LINKS,
    PROFILE_SUBMENU_LINKS,
} from '@marketplace/components/nav/config/header-menu-links.js'
import NavItem from '@marketplace/components/nav/nav-item.vue'
import CurrentLanguageMenuItem from '@marketplace/components/nav/parts/current-language-menu-item.vue'
import HeaderCoreSearch from '@marketplace/components/nav/parts/header-core-search.vue'
import ThePromoBar from '@marketplace/components/nav/parts/ThePromoBar.vue'
import PulseTooltipWrapper from '@marketplace/components/pulse/pulse-tooltip-wrapper.vue'
import ocDrawerMixin from '@marketplace/components/shared/drawer/ocDrawerMixin.js'
import OrderchampLogo from '@marketplace/components/shared/icons/OrderchampLogo.vue'
import TicaOrderchampLogo from '@marketplace/components/shared/icons/TicaOrderchampLogo.vue'
import { CORE_COUNTRIES } from '@marketplace/config/country.js'
import { trackHeaderClick } from '@marketplace/helpers/segment/index.js'
import { navigateToDropshipping } from '@marketplace/helpers/url.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'
import { mapGetters } from 'vuex'

export default {
    name: 'HeaderMarketplace',

    components: {
        OrderchampLogo,
        TicaOrderchampLogo,
        HeaderCoreSearch,
        HeaderMobileMenu,
        HeaderInlineMenu,
        ThePromoBar,
        HeaderCart,
        CurrentLanguageMenuItem,
        HowOcWorksOptions,
        AccountDrawer,
        PulseTooltipWrapper,
        NavItem,
    },

    mixins: [ocDrawerMixin],

    data() {
        return {
            showDropdownMenu: false,
            dropdownMenuTimeout: null,
            userType: window.Store.accountType,
            guestLinks: GUEST_LINKS,
            isDropshippingHovered: false,
        }
    },
    computed: {
        ...mapGetters('feature', ['hasDropshippingFeature']),
        ...mapGetters('global', [
            'account',
            'cartProductsCount',
            'inboxUnreadCount',
            'isAssociationRetailer',
            'userCountry',
            'showTicaLogo',
        ]),
        ...mapGetters('ocplus', ['canSeeOcPlus']),

        isInCoreCountry() {
            return CORE_COUNTRIES.includes(this.userCountry.toUpperCase())
        },

        howDropshippingWorksUrl() {
            return navigateToDropshipping()
        },

        profileLinks() {
            return PROFILE_SUBMENU_LINKS.filter((item) => {
                if (!item.path?.startsWith('/ds')) {
                    return true
                }

                return this.showDropshippingToggle
            })
        },

        showDropshippingToggle() {
            return this.account?.dropshipping?.status === 'APPROVED'
        },
    },

    mounted() {
        this.$store.commit(
            'global/updateHeaderHeight',
            this.$refs.header.clientHeight
        )
    },

    methods: {
        trackHeaderClick,
        triggerHamburgerMenu() {
            this.__openDrawer('hamburger')
        },

        openAccountDrawer() {
            this.__openDrawer('account')
        },

        triggerLanguageCurrencyModal() {
            EventBus.$emit('modal-open', 'modal-language-picker')
        },

        openDropdownMenu() {
            this.showDropdownMenu = true
            clearTimeout(this.dropdownMenuTimeout)
        },

        closeDropdownMenu() {
            this.dropdownMenuTimeout = setTimeout(() => {
                this.showDropdownMenu = false
            }, 150)
        },

        canBeShown(hiddenFor, path) {
            // Don't render the '/account/plus' path if the user is not in a core country
            if (path === '/account/plus' && !this.isInCoreCountry) {
                return false
            }

            if (!hiddenFor) return true

            if (
                hiddenFor.includes('supplier') &&
                this.$helpers.isSupplierAccount
            ) {
                return false
            }

            if (
                hiddenFor.includes('notAssociationMember') &&
                this.isAssociationRetailer
            ) {
                return false
            }

            if (hiddenFor.includes('isOCPlus') && !this.canSeeOcPlus) {
                return false
            }

            if (!hiddenFor.includes(this.userType)) return true

            return false
        },

        handleDynamicComponentClick(methodToCall) {
            if (!methodToCall) {
                return
            }

            switch (methodToCall) {
                case 'triggerLanguageCurrencyModal':
                    this.triggerLanguageCurrencyModal()
                    break
            }
        },
    },
}
